import {MenuItemAggregate} from '../../../../../aggregats/menu/menu-item.aggregate';
import {AutorisationsAggregate} from '../../../../../aggregats/autorisation/autorisations.aggregate';
import {AutorisationAggregate} from '../../../../../aggregats/autorisation/autorisation.aggregate';
import {FonctionLogicielle} from '../../../../fonctions-logicielle-constantes';
import {EparcoursPath} from '../../eparcours-path';

export const agendaTachesMenuItem: MenuItemAggregate = new MenuItemAggregate(
  'icon-calendar',
  'Mon planning',
  null,
  `/${EparcoursPath.root.AGENDA_TACHES}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Taches)]),
);
